import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: {},
  loaded: false,

  selectedCategories: {},
  selectedCategoriesError: {},
  selectedCategoriesSuccess: false,
  selectedCategoriesLoading: false,
})

const { Types, Creators } = createActions({
  fetchMenusRequest: null,
  fetchMenusConnected: ['data'],
  fetchMenusError: ['error'],
  fetchMenusDisconnected: null,

  fetchSelectedCategoriesRequest: null,
  fetchSelectedCategoriesConnected: ['data'],
  fetchSelectedCategoriesError: ['error'],
  fetchSelectedCategoriesDisconnected: null,
})

export const menusRequest = state => state.set('loading', true)

export const menusDisconnected = state => state.set('loading', false).set('loaded', false)

export const menusConnected = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)
    .set('loaded', true)

export const menusError = (state, { error }) =>
  state
    .set('error', error)
    .set('loading', false)
    .set('loaded', true)

export const selectedCategoriesRequest = state => state.set('selectedCategoriesLoading', true)
export const selectedCategoriesDisconnected = state => state.set('selectedCategoriesLoading', false)
export const selectedCategoriesConnected = (state, { data }) =>
  state
    .set('selectedCategories', data)
    .set('selectedCategoriesLoading', false)
    .set('selectedCategoriesSuccess', true)
export const selectedCategoriesErrorReducer = (state, { error }) =>
  state.set('selectedCategoriesError', error).set('selectedCategoriesLoading', false)

export const menuReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_MENUS_REQUEST]: menusRequest,
  [Types.FETCH_MENUS_CONNECTED]: menusConnected,
  [Types.FETCH_MENUS_DISCONNECTED]: menusDisconnected,
  [Types.FETCH_MENUS_ERROR]: menusError,

  [Types.FETCH_SELECTED_CATEGORIES_REQUEST]: selectedCategoriesRequest,
  [Types.FETCH_SELECTED_CATEGORIES_CONNECTED]: selectedCategoriesConnected,
  [Types.FETCH_SELECTED_CATEGORIES_DISCONNECTED]: selectedCategoriesDisconnected,
  [Types.FETCH_SELECTED_CATEGORIES_ERROR]: selectedCategoriesErrorReducer,
})

export const MenuTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js